import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS, getData } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { useParams } from 'react-router-dom';

export default function DoctorPortal() {
  const [tests, setTests] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const { appointment_id } = useParams();

  // Example variables (replace with your actual logic)
  const token = getToken();
  const user_id = decodeToken(token, 'id');
  const date = new Date().toISOString().split('T')[0]; // e.g. '2025-07-03'
  const SUBMIT_URL = `${API_URL}/${ENDPOINTS.SYS}/create/register-caafi_lab_request`;

  useEffect(() => {
    // Fetch the data from your API
    const url = `${API_URL}/${ENDPOINTS.SYS}/getlink/doctor-lab-request`;
    const fetchData = async () => {
      const response = await getData(url);
      setTests(response.report);
    };
    fetchData();
  }, []);

  const handleCheckboxChange = (testName) => {
    setSelectedTests((prev) =>
      prev.includes(testName)
        ? prev.filter((name) => name !== testName)
        : [...prev, testName]
    );
  };
  const handleGroupCheckboxChange = (groupName) => {
    const groupItems = groupedTests[groupName].tests.map(
      (item) => item.TestName
    ); // ✅ FIXED
    const allSelected = groupItems.every((name) =>
      selectedTests.includes(name)
    );

    if (allSelected) {
      // Uncheck all in this group
      setSelectedTests((prev) =>
        prev.filter((name) => !groupItems.includes(name))
      );
    } else {
      // Add missing ones
      setSelectedTests((prev) => [
        ...prev,
        ...groupItems.filter((name) => !prev.includes(name)),
      ]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedLabItems = tests.filter((test) =>
      selectedTests.includes(test.TestName)
    );

    const requests = selectedLabItems.map((item) => {
      const body = {
        user_id,

        appointment_id,
        lab_item_id: item.labItemId, // assumes your test object has labItemId field
        status: 'scheduled',
        date,
      };

      return axios
        .post(SUBMIT_URL, body, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        })
        .then((response) => {
          console.log(`Submitted:`, body, 'Response:', response.data);
          return response.data;
        })
        .catch((error) => {
          console.error(`Error submitting:`, body, error);
          throw error;
        });
    });

    try {
      const results = await Promise.all(requests);
      console.log('All submitted:', results);
      // Count success and failed
      let successCount = 0;
      let failedCount = 0;

      results.forEach((result) => {
        if (result.status === false) {
          failedCount++;
        } else {
          successCount++;
        }
      });

      alert(
        `Tests submitted.\nSuccess: ${successCount}\nFailed: ${failedCount}`
      );
    } catch (error) {
      alert('Some requests failed — check console for details.');
    }
  };

  // Group tests by `Group`
  const groupedTests = tests.reduce((acc, test) => {
    if (!acc[test.Group]) {
      acc[test.Group] = { category: test.Category, tests: [] };
    }
    acc[test.Group].tests.push(test);
    return acc;
  }, {});

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Lab Tests</h1>
      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1rem',
          }}
        >
          {Object.entries(groupedTests).map(([groupName, groupData]) => {
            const groupItems = groupData.tests.map((test) => test.TestName);
            const allSelected = groupItems.every((name) =>
              selectedTests.includes(name)
            );
            const category = groupData?.category;

            return (
              <div
                key={groupName}
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  padding: '1rem',
                  background: '#fafafa',
                }}
              >
                <h6>
                  <label>
                    <input
                      type="checkbox"
                      checked={allSelected}
                      onChange={() => handleGroupCheckboxChange(groupName)}
                      style={{ marginRight: '0.5rem' }}
                    />
                    {groupName}{' '}
                    {/* <span style={{ fontSize: '0.85rem', color: '#555' }}>
                      ({category})
                    </span> */}
                  </label>
                </h6>
                <ul
                  style={{
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    marginLeft: 20,
                  }}
                >
                  {groupData.tests.map((test) => (
                    <li key={test.TestName} style={{ marginBottom: '0.5rem' }}>
                      <label>
                        <input
                          type="checkbox"
                          checked={selectedTests.includes(test.TestName)}
                          onChange={() => handleCheckboxChange(test.TestName)}
                          style={{ marginRight: '0.5rem' }}
                        />
                        {test.TestName}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
        <button
          type="submit"
          style={{
            marginTop: '2rem',
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
          }}
        >
          Submit Selected Tests
        </button>
      </form>
    </div>
  );
}
